import React from 'react';
// import { Link } from 'react-router-dom'; // Uncomment if using React Router

const ServiceCard = ({ name, description, image, learnMoreLink, icon }) => {
  // Determine if using an icon or an image
  const hasIcon = icon && typeof icon === 'string'; // Check if icon is a path or could be a component
  const hasImage = image && typeof image === 'string';

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 ease-in-out flex flex-col">
      {/* Image or Icon Section */}
      {hasImage && (
        <div className="w-full h-48 overflow-hidden rounded-t-lg">
          <img 
            src={image} 
            alt={`${name} service visual`} 
            className="w-full h-full object-cover" 
          />
        </div>
      )}
      {!hasImage && hasIcon && ( // Display icon if no image and icon is provided
        <div className="p-6 flex justify-center items-center h-48 rounded-t-lg bg-brand-green-lightest"> {/* Example background for icon */}
          {/* If icon is an SVG path or component */}
          {/* For SVG path: <img src={icon} alt={`${name} icon`} className="w-16 h-16 text-brand-green" /> */}
          {/* Or if icon is a React component: <IconComponent className="w-16 h-16 text-brand-green" /> */}
          <span className="text-5xl text-brand-green">ICON</span> {/* Placeholder if icon is just a string path */}
        </div>
      )}
      {!hasImage && !hasIcon && ( // Fallback if neither image nor icon is provided
         <div className="w-full h-48 bg-gray-100 rounded-t-lg flex items-center justify-center">
            <span className="text-gray-400">No Image</span>
        </div>
      )}

      {/* Content Section */}
      <div className="p-6 flex-grow flex flex-col">
        <h3 className="text-xl font-semibold text-brand-gray-dark mb-2">{name}</h3>
        <p className="text-sm text-brand-gray mb-4 flex-grow">{description}</p>
        <a
          href={learnMoreLink} // Replace with Link component if using React Router
          className="mt-auto self-start text-brand-green hover:text-brand-green-dark font-semibold transition duration-300 ease-in-out group"
        >
          Learn More 
          <span className="ml-1 transition-transform duration-300 ease-in-out group-hover:translate-x-1">&rarr;</span>
        </a>
      </div>
    </div>
  );
};

export default ServiceCard; 